import { render, staticRenderFns } from "./TramiteCardComponent.vue?vue&type=template&id=5bfd5636&scoped=true"
import script from "./TramiteCardComponent.vue?vue&type=script&lang=ts"
export * from "./TramiteCardComponent.vue?vue&type=script&lang=ts"
import style0 from "./TramiteCardComponent.vue?vue&type=style&index=0&id=5bfd5636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd5636",
  null
  
)

export default component.exports